export const QUERY_PARAMETER_LANGUAGE = "lang";
export const LANGUAGE_CODE_RO = "ro";
export const LANGUAGE_CODE_EN = "en";